import { Container } from 'react-bootstrap'
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import Accordion from 'react-bootstrap/Accordion';

function Jornal() {
  return (
    <Container>
      <Accordion defaultActiveKey="0" className="mt-3 mb-3">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Edição nº 09 - Julho/2025</Accordion.Header>
          <Accordion.Body>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.js">
              <Viewer fileUrl="/documents/jornal_001.pdf" />
            </Worker>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  )
}

export default Jornal